import get from 'lodash-es/get'

import { getUserProfileRequest, formatUserResponse } from '../../utils/user'
import { getSession } from '../../utils/auth'
import { getGuestUserCart } from './cart'
import bootIntercom from '../../utils/bootIntercom'
import { logError } from '../../utils/errors'
import { setGAUserID } from '../../analytics/userAnalytics'
import { showAlert } from '../common'
import {
  getSessionRequestAction,
  getSessionSuccessAction,
  getSessionFailureAction
} from './session'
import {
  getUserRequestAction,
  getUserSuccessAction,
  getUserFailureAction,
  getGuestUserAction
} from './profile'

const USER_CONFIRMATION_PATH = '/user_confirmation'

/**
 * When SSO request failed
 */
const handleUnAuthenticatedAction = () => {
  return dispatch => {
    dispatch(getGuestUserAction())
    bootIntercom.boot()
    // get guest user cart
    return dispatch(getGuestUserCart())
  }
}

const handleDisabledUser = () => dispatch => {
  dispatch(
    showAlert(
      "Sorry, it looks like you're currently locked out of your account. Please contact <a href='https://help.market.envato.com/hc/en-us/requests/new'>Help Team</a> for more details.",
      'warning'
    )
  )
  dispatch(getSessionFailureAction())
  return dispatch(getUserFailureAction())
}

const getUSDollarsNotice = usDollarsNotice => ({
  type: 'getUSDollarsNotice',
  payload: { usDollarsNotice: usDollarsNotice }
})

export const getUserProfile = jwtToken => dispatch => {
  dispatch(getUserRequestAction())
  return getUserProfileRequest(jwtToken)
    .then(formatUserResponse)
    .then(user => {
      // until the user_confirmation page is hosted under shopfront, we can only use external urls instead of using React-router `Link`
      if (user.profile && !get(user, 'profile.accepted_initial_terms')) {
        window.location = USER_CONFIRMATION_PATH
      }

      bootIntercom.boot(user)
      setGAUserID(get(user, 'profile.id'))
      return dispatch(getUserSuccessAction(user))
    })
    .catch(err => {
      const res = err.response
      if (res && res.status === 403 && res.data.reason === 'user-disabled') {
        return dispatch(handleDisabledUser())
      } else {
        return Promise.reject(logError(err))
      }
    })
    .catch(() => {
      return dispatch(getUserFailureAction())
    })
}

export const getUser = () => {
  return (dispatch, getState) => {
    dispatch(getSessionRequestAction())

    return getSession()
      .then(res => {
        dispatch(getSessionSuccessAction(res.data.token))
        dispatch(getUserProfile(res.data.token))
        dispatch(getUSDollarsNotice(res.headers['x-display-us-dollars-notice']))
      })
      .catch(err => {
        if (get(err, 'response.status') === 401) {
          dispatch(
            getUSDollarsNotice(
              get(err, 'response.headers', {})['x-display-us-dollars-notice']
            )
          )
          return dispatch(handleUnAuthenticatedAction())
        } else {
          return dispatch(getSessionFailureAction())
        }
      })
  }
}
